'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { FILE_MANAGER_DELETE_SCOPE, ObjectCategory } from 'FileManagerCore/Constants';
import { isFile } from 'FileManagerCore/utils/FoldersAndFiles';
import { selectIsUngatedForPermissions, selectUserHasFileManagerDeleteScope } from 'FileManagerCore/selectors/Auth';
import { getIsReadOnly } from 'FileManagerCore/selectors/Permissions';
import ScopedFeatureTooltip from 'FileManagerCore/components/permissions/ScopedFeatureTooltip';
import * as ModalTypes from '../../enums/ModalTypes';
import { openModal } from '../../actions/Actions';
import { jsx as _jsx } from "react/jsx-runtime";
class DeleteFileOrFolderButton extends Component {
  constructor(...args) {
    super(...args);
    this.handleButtonClick = () => {
      const {
        fileOrFolder
      } = this.props;
      const objectCategory = isFile(fileOrFolder) ? ObjectCategory.FILE : ObjectCategory.FOLDER;
      const modalType = isFile(fileOrFolder) ? ModalTypes.DELETE_FILE : ModalTypes.DELETE_FOLDER;
      this.props.openModal(modalType, {
        objectCategory,
        objectId: fileOrFolder.get('id')
      });
    };
  }
  render() {
    const {
      hasDeleteScope,
      isReadOnly,
      isUngatedForPermissions,
      size,
      fileOrFolder
    } = this.props;
    return /*#__PURE__*/_jsx(ScopedFeatureTooltip, {
      scope: FILE_MANAGER_DELETE_SCOPE,
      children: /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "panel-delete-button",
        size: size,
        use: "tertiary-light",
        onClick: this.handleButtonClick,
        disabled: isReadOnly || isUngatedForPermissions && !hasDeleteScope,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `FileManagerCore.actions.${isFile(fileOrFolder) ? 'trash' : 'delete'}`
        })
      })
    });
  }
}
DeleteFileOrFolderButton.propTypes = {
  size: UIButton.propTypes.size,
  fileOrFolder: PropTypes.instanceOf(Immutable.Map),
  isReadOnly: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  isUngatedForPermissions: PropTypes.bool.isRequired,
  hasDeleteScope: PropTypes.bool.isRequired
};
DeleteFileOrFolderButton.defaultProps = {
  size: 'small'
};
const mapDispatchToProps = {
  openModal
};
const mapStateToProps = state => ({
  isReadOnly: getIsReadOnly(state),
  isUngatedForPermissions: selectIsUngatedForPermissions(state),
  hasDeleteScope: selectUserHasFileManagerDeleteScope(state)
});
export default connect(mapStateToProps, mapDispatchToProps)(DeleteFileOrFolderButton);